 
          // Helper: Map currency codes to symbols
          function getCurrencySymbol() {
            // Check if Shopify currency data is available
            if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
              var activeCurrency = Shopify.currency.active;
              var symbols = {
                'USD': '$',
                'EUR': '€',
                'GBP': '£',
                'CAD': '$',
                'AUD': '$',
                'JPY': '¥'
                // add more mappings as needed
              };
              return symbols[activeCurrency] || activeCurrency;
            }
            // Default fallback symbol
            return '$';
          }
          
          // Helper: Round up to next whole number
          function roundUpPrice(cents) {
            return Math.ceil(cents / 100) * 100;
          }
          
          // Updated formatMoney function with decimal handling
          function formatMoney(cents) {
            var symbol = getCurrencySymbol();
            // Convert cents to dollars and keep decimal places
            var dollars = cents / 100;
            // Format to 2 decimal places without rounding
            var formatted = dollars.toFixed(2);
            return symbol + formatted;
          }
          
          document.addEventListener('DOMContentLoaded', function() {
              console.log('Bundle script initialized');
           document.querySelectorAll('.lux-bundle-builder').forEach(bundle => {
            
            let selectedPack = '3';
            let totalScents = 0;
           
            const productId = bundle.dataset.productId;
              if(productId == 8322126774407)
                  {
                      selectedPack = '6';
                  }
                  else{
                      selectedPack = '3';

                  }
            const productData = JSON.parse(
            document.getElementById(`productData-${productId}`).textContent
            );
            
            function updateSubtotalAndSavings() {
              let originalPrice, finalPrice, savings;
            
              if (selectedPack === '3') {
                originalPrice = roundUpPrice(productData.threePackCompare);
                finalPrice = roundUpPrice(productData.threePackPrice);
                savings = originalPrice - finalPrice;
                
                // Update per-unit price for 3 pack (use rounded final price)
                const threePackPriceEl = bundle.querySelector('.lux-pack-option[data-pack="3"] .lux-pack-price');
                const perUnitPrice = finalPrice / 3; // Use rounded final price
                threePackPriceEl.textContent = `${formatMoney(perUnitPrice)} / ea`;
              } else if (selectedPack === '2') {
                originalPrice = roundUpPrice(productData.twoPackCompare);
                finalPrice = roundUpPrice(productData.twoPackPrice);
                savings = originalPrice - finalPrice;

                if(productId != 8322126774407)
                {

                    // Update per-unit price for 2 pack (use rounded final price)
                    const twoPackPriceEl = bundle.querySelector('.lux-pack-option[data-pack="2"] .lux-pack-price');
                    const perUnitPrice = finalPrice / 2; // Use rounded final price
                    twoPackPriceEl.textContent = `${formatMoney(perUnitPrice)} / ea`;
                  }
                  } else {
                    originalPrice = roundUpPrice(productData.compareAtPrice);
                    finalPrice = roundUpPrice(productData.price);
                    savings = originalPrice - finalPrice;
                
                // Update per-unit price for 1 pack
                const onePackPriceEl = bundle.querySelector('.lux-pack-option[data-pack="1"] .lux-pack-price');
                onePackPriceEl.textContent = `${formatMoney(finalPrice)} / ea`; // Use rounded final price
              }
            
              const originalPriceEl = bundle.querySelector('.original-price');
              const finalPriceEl = bundle.querySelector('.final-price');
              const savingsEl = bundle.querySelector('.savings-text');
            
              originalPriceEl.textContent = (Shopify && Shopify.formatMoney) ? 
                Shopify.formatMoney(originalPrice) : formatMoney(originalPrice);
              finalPriceEl.textContent = (Shopify && Shopify.formatMoney) ? 
                Shopify.formatMoney(finalPrice) : formatMoney(finalPrice);
            
              if (savings > 0) {
                savingsEl.textContent = `YOU'RE SAVING ${(Shopify && Shopify.formatMoney) ? 
                  Shopify.formatMoney(savings) : formatMoney(savings)}`;
                savingsEl.parentElement.style.display = 'flex';
              } else {
                savingsEl.parentElement.style.display = 'none';
              }
            }
  
            
    // Check stock status and disable out of stock variants
    bundle.querySelectorAll('.lux-scent-option').forEach(option => {
      const variantId = option.querySelector('.lux-quantity-input').dataset.variantId;
      const variant = productData.variants.find(v => v.id === parseInt(variantId));
      
      if (variant && !variant.available) {
        option.classList.add('out-of-stock');
      }
    });
  
    // Update selected pack text
    function updateSelectedPackText() {
      const selectedPackValue = bundle.querySelector('.selected-pack-value');
      selectedPackValue.textContent = `${selectedPack} Pack`;
    }
  
    // Pack Selection
    bundle.querySelectorAll('.lux-pack-option').forEach(option => {
      option.addEventListener('click', function() {
        const pack = this.dataset.pack;
        selectedPack = pack;
        bundle.querySelectorAll('.lux-pack-option').forEach(opt => opt.classList.remove('lux-selected'));
        this.classList.add('lux-selected');
        
        // Reset quantities when changing packs
        bundle.querySelectorAll('.lux-quantity-input').forEach(input => {
          input.value = 0;
          const scentOption = input.closest('.lux-scent-option');
          scentOption.querySelector('.lux-scent-quantity').classList.remove('show');
          scentOption.querySelector('.add-button').classList.remove('hidden');
        });
        totalScents = 0;
        
        updateSelectedPackText();
        updateTotalAndValidation();
        updateSubtotalAndSavings();
      });
    });
  
    // Add Button Click Handler
    bundle.querySelectorAll('.add-button').forEach(btn => {
      btn.addEventListener('click', function() {
        const scentOption = this.closest('.lux-scent-option');
        const quantitySection = scentOption.querySelector('.lux-scent-quantity');
        const input = quantitySection.querySelector('.lux-quantity-input');
        
        // Show quantity controls and hide add button
        quantitySection.classList.add('show');
        this.classList.add('hidden');
        
        // Set initial quantity to 1
        input.value = 1;
        totalScents++;
        
        updateTotalAndValidation();
        updateSubtotalAndSavings();
      });
    });
  
    function updateTotalAndValidation() {
      const remainingScents = parseInt(selectedPack) - totalScents;
      const scentCounter = bundle.querySelector('.lux-scent-counter');
      
      if (remainingScents === 0) {
        scentCounter.innerHTML = 'ALL SET';
        scentCounter.style.backgroundColor = '#FAEADC';
        scentCounter.style.color = '#6C4E3E';
        // Disable all remaining ADD buttons when all set
        bundle.querySelectorAll('.add-button:not(.hidden)').forEach(btn => {
          btn.disabled = true;
          btn.style.backgroundColor = '#ccc';
        });
      } else if (remainingScents > 0) {
        scentCounter.innerHTML = `ADD <span id="lux-remaining-scents">${remainingScents}</span> MORE SCENTS`;
        // Enable ADD buttons when spots are available
        bundle.querySelectorAll('.add-button:not(.hidden)').forEach(btn => {
          btn.disabled = false;
          btn.style.backgroundColor = '#6C4E3E';
        });
      }
      
      // Enable/disable add to cart
      const addToCartBtn = bundle.querySelector('#lux-add-to-cart');
      addToCartBtn.disabled = totalScents !== parseInt(selectedPack);
    }
  
    // Quantity Controls
    bundle.querySelectorAll('.lux-quantity-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const input = this.parentElement.querySelector('.lux-quantity-input');
        const currentValue = parseInt(input.value);
        const maxAllowed = parseInt(selectedPack);
        const scentOption = this.closest('.lux-scent-option');
        
        if (this.classList.contains('lux-plus')) {
          // Prevent increasing if we're already at max total scents
          if (totalScents >= maxAllowed) {
            return;
          }
          
          if (currentValue < maxAllowed) {
            if (selectedPack === '1') {
              bundle.querySelectorAll('.lux-quantity-input').forEach(otherInput => {
                if (otherInput !== input) {
                  otherInput.value = 0;
                  const otherScentOption = otherInput.closest('.lux-scent-option');
                  otherScentOption.querySelector('.lux-scent-quantity').classList.remove('show');
                  otherScentOption.querySelector('.add-button').classList.remove('hidden');
                  otherScentOption.querySelector('.add-button').disabled = false;
                  otherScentOption.querySelector('.add-button').style.backgroundColor = '#8B6B5C';
                }
              });
              totalScents = 0;
            }
            input.value = currentValue + 1;
            totalScents++;
          }
        } else if (this.classList.contains('lux-minus')) {
          if (currentValue > 0) {
            input.value = currentValue - 1;
            totalScents--;
            
            // If quantity becomes 0, hide quantity controls and show add button
            if (input.value === '0') {
              scentOption.querySelector('.lux-scent-quantity').classList.remove('show');
              const addButton = scentOption.querySelector('.add-button');
              addButton.classList.remove('hidden');
              addButton.disabled = false;
              addButton.style.backgroundColor = '#8B6B5C';
            }
          }
        }
        
        updateTotalAndValidation();
        updateSubtotalAndSavings();
      });
    });
  
    // Add to Cart Functionality
    bundle.querySelector('#lux-add-to-cart').addEventListener('click', function() {
      const addToCartBtn = this;
      addToCartBtn.classList.add('is-loading');
      
      const items = [];
      
      bundle.querySelectorAll('.lux-quantity-input').forEach(input => {
        const quantity = parseInt(input.value);
        if (quantity > 0) {
          items.push({
            id: parseInt(input.dataset.variantId),
            quantity: quantity
          });
        }
      });
  
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          items: items
        },
        dataType: 'json',
        success: function(n) {
          var cart = new theme.CartDrawer;
          cart.init();
          cart.open();
          
          // Update cart count and remove loading state
          $.getJSON('/cart.js', function(cart) {
            $('.drcart_count').text(cart.item_count);
          }).always(function() {
            addToCartBtn.classList.remove('is-loading');
          });
        },
        error: function() {
          alert('There was an error adding items to cart. Please try again.');
          addToCartBtn.classList.remove('is-loading');
        }
      });
    });
  
    // Initialize with default values
    // bundle.querySelector('.lux-pack-option[data-pack="3"]').classList.add('lux-selected');
    // bundle.querySelector('.lux-pack-option[data-pack="6"]').classList.add('lux-selected');
    bundle.querySelectorAll('.lux-pack-option[data-pack="3"]').forEach(el => {
      el.classList.add('lux-selected')
      
    });
    bundle.querySelectorAll('.lux-pack-option[data-pack="6"]').forEach(el => {
      el.classList.add('lux-selected');
    });

    updateSelectedPackText();
    updateTotalAndValidation();
    updateSubtotalAndSavings();

    // Initialize per-unit prices for all pack options
    function initializePerUnitPrices() {
      const threePackPrice = roundUpPrice(productData.threePackPrice);
      const twoPackPrice = roundUpPrice(productData.twoPackPrice);
      const onePackPrice = roundUpPrice(productData.price);

      // Set 3-pack per-unit price
      const threePackPriceEl = bundle.querySelector('.lux-pack-option[data-pack="3"] .lux-pack-price');
      threePackPriceEl.textContent = `${formatMoney(threePackPrice / 3)} / ea`;

      // Set 2-pack per-unit price
      const twoPackPriceEl = bundle.querySelector('.lux-pack-option[data-pack="2"] .lux-pack-price');
      twoPackPriceEl.textContent = `${formatMoney(twoPackPrice / 2)} / ea`;

      // Set 1-pack per-unit price
      const onePackPriceEl = bundle.querySelector('.lux-pack-option[data-pack="1"] .lux-pack-price');
      onePackPriceEl.textContent = `${formatMoney(onePackPrice)} / ea`;
    }

    // Call initialization
    initializePerUnitPrices();
  });
});
 

